export default __webpack_public_path__ + "static/media/Ballroll_00126.76a4b9f9.png";